import React, { useState } from "react";
import DropdownMenu from "./DropdownMenu";
import InputDropdown from "./InputDropdown";
import VideoPlayer from "../VideoPlayer";
import AppleIcon from '@mui/icons-material/Apple';
import AndroidIcon from '@mui/icons-material/Android';
import { skillData, subCatData } from "./skillRawData";
import { getPlaystoreLinks } from "../../../Utils/attribution";

const SkillDetails = ({
  handleChange,
  values,
  errors,
  touched,
  setFieldTouched,
  setFieldValue,
  isEnglish,
}) => {
  const [showCustomInput, setShowCustomInput] = useState(false);
  const [subCatInput, setSubCatInput] = useState("");
  const videoData = {
    ImageLink:
      "https://blaccsckullplatformsprivatelim.box.com/shared/static/bhehuldyai8a9pdo1cb3yjatxmewo6ph.png",
    VideoLink: "https://blaccsckullplatformsprivatelim.box.com/shared/static/8vbk9h55smdhn8un01d2xlp5biv6bxar.mp4",
  }

  const t = {
    skillLabel: isEnglish ? "Skill Category*" : "कौशल श्रेणी*",
    skillPlaceholder: isEnglish ? "Choose an option" : "एक विकल्प चुनें",
    subSkillLabel: isEnglish ? "Skill Sub-Category*" : "कौशल उप-श्रेणी*",
    subSkillPlaceholder: isEnglish
      ? "Select Sub-Category"
      : "उप-श्रेणी चुनें",
    customInputPlaceholder: isEnglish
      ? "Enter sub-category"
      : "उप-श्रेणी दर्ज करें",
    add: isEnglish ? "Add" : "जोड़ें",
    expLabel: isEnglish ? "Years of Experience*" : "अनुभव के वर्ष*",
    expPlaceholder: isEnglish
      ? "Minimum 8 years required"
      : "कम से कम 8 वर्ष आवश्यक",
    infoBanner: isEnglish? [
      "🏆 Judge 4–5 contests/month | ⏰ 48 h to submit reviews | 🚫 No live presence needed",
      "Judges have 48 hr window after contest closes to submit reviews (no live presence required)."
    ] : [
      "🏆 महीने में 4–5 प्रतियोगिताएँ जज करें | ⏰ समीक्षाएँ जमा करने के लिए 48 घंटे | 🚫 लाइव उपस्थिति आवश्यक नहीं",
      "प्रतियोगिता बंद होने के बाद जजों के पास समीक्षाएँ जमा करने के लिए 48 घंटे का समय होता है (लाइव उपस्थिति आवश्यक नहीं)।"
    ],
    demoVideoLabel: isEnglish
      ? "Watch Demo (How marks are assigned)"
      : "डेमो देखें (अंक कैसे निर्धारित किए जाते हैं)",
    downloadAppText: isEnglish
      ? "Download the Feedants app for a smoother experience..."
      : "बेहतर अनुभव के लिए Feedants ऐप डाउनलोड करें..."
  };

  const { intentUrl , playStoreLink } = getPlaystoreLinks();
  const ua = window.navigator.userAgent || navigator.vendor || window.opera;
  const isAndroid = ua.includes("Android");
  const playstoreIntentUrl = isAndroid? intentUrl: playStoreLink;

  const inputBaseClass =
    "w-full border border-gray-300 rounded-lg px-3 py-2 text-sm text-[#0D1C2E] font-[Gilroy-Regular] focus:outline-none focus:ring focus:ring-blue-200";

  return (
    <div className="flex flex-col gap-4 mt-3">
      {/* Skill Category */}
      <div>
        <label className="text-base font-[Gilroy-Medium] text-[#0D1C2E] tracking-tight">
          {t.skillLabel}
        </label>
        <DropdownMenu
          data={skillData}
          selectedItem={values.skill}
          onSelect={(val) => {
            handleChange("skill")(val);
            setFieldValue("subCat", "");
            setShowCustomInput(false);
          }}
          placeholder={t.skillPlaceholder}
          setFieldTouched={setFieldTouched}
        />
        {touched.skill && errors.skill && (
          <p className="text-sm text-red-500 mt-1">{errors.skill}</p>
        )}
      </div>

      {/* Sub Category */}
      <div>
        <label className="text-base font-[Gilroy-Medium] text-[#0D1C2E] tracking-tight">
          {t.subSkillLabel}
        </label>
        <InputDropdown
          data={values.skill ? subCatData[values.skill] || [] : []}
          selectedItem={showCustomInput ? "other" : values.subCat}
          onSelect={(val) => {
            if (val !== "other") {
              setFieldValue("subCat", val);
            } else {
              setShowCustomInput(true);
              setFieldValue("subCat", "");
            }
          }}
          placeholder={t.subSkillPlaceholder}
          disabled={!values.skill}
          setFieldTouched={setFieldTouched}
        />
        {showCustomInput && !values?.subCat && (
          <div className="flex items-center gap-2 mt-2">
            <input
              type="text"
              placeholder={t.customInputPlaceholder}
              value={subCatInput}
              onChange={(e) => setSubCatInput(e.target.value)}
              className={`${inputBaseClass} flex-1`}
            />
            <button
              onClick={() => {
                setShowCustomInput(false);
                setFieldValue("subCat", subCatInput);
                setSubCatInput("");
              }}
              className="px-4 py-2 bg-[#008080] text-white rounded-lg font-medium"
            >
              {t.add}
            </button>
          </div>
        )}
        {touched.subCat && errors.subCat && (
          <p className="text-sm text-red-500 mt-1">{errors.subCat}</p>
        )}
      </div>

      {/* Experience */}
      <div>
        <label className="text-base font-[Gilroy-Medium] text-[#0D1C2E] tracking-tight">
          {t.expLabel}
        </label>
        <input
          type="number"
          maxLength={2}
          onChange={(e) => handleChange("yearsOfExp")(e)}
          onBlur={() => setFieldTouched("yearsOfExp")}
          value={values.yearsOfExp || ""}
          placeholder={t.expPlaceholder}
          className={inputBaseClass}
        />
        {touched.yearsOfExp && errors.yearsOfExp && (
          <p className="text-sm text-red-500 mt-1">{errors.yearsOfExp}</p>
        )}
      </div>

      <ul className="py-1 flex flex-col gap-1 text-gray-500 font-medium text-sm tracking-tighter">
        <li>
          {t.infoBanner[0]}
        </li>
        <li>
          {t.infoBanner[1]}
        </li>
      </ul>

      <div className="">
        <h1 className="tracking-tight text-base font-bold text-transparent bg-clip-text bg-gradient-to-r from-[#021C1C] to-[#043333]">
          {t.demoVideoLabel}
        </h1>

        <div className="relative rounded-xl overflow-hidden border border-gray-200">
          <VideoPlayer
            src={videoData?.VideoLink}
            poster={videoData?.ImageLink}
            className="h-40 w-full"
          />
        </div>
      </div>

      {/* Download CTA */}
      <div className="mt-4 py-2 flex flex-col gap-2">
          <h1 className="text-base text-[#043333] font-medium tracking-tight text-center">
              {t.downloadAppText}
          </h1>
        <div className="flex flex-row gap-2 text-sm">
          <a
          href={playstoreIntentUrl}
          className="flex-1 px-4 py-3 border border-[#008080] rounded-xl text-[#008080] flex items-center justify-center"
        >
          <AndroidIcon className="text-[#008080] size-4 mr-2"/>
          Play Store
        </a>
        <a
           href={"https://apps.apple.com/in/app/feedants/id6477408585"}
          className="flex-1 px-4 py-3 border border-[#008080] rounded-xl text-[#008080] flex items-center justify-center"
        >
          <AppleIcon className="text-[#008080] size-4 mr-2"/>
          Apple Store
        </a>
        </div>
      </div>
    </div>
  );
};

export default SkillDetails;
